import { useQuery } from 'react-query';
import {
  WDAC_CATALOG_INVENTORY_DETAILS_QUERY_KEY,
} from '../../constants/query';
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import CatalogInventoryService from '../../services/catalog-inventory.service';

const useGetCatalogInventoryDetails = ({ catalogInventoryId }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  return useQuery([WDAC_CATALOG_INVENTORY_DETAILS_QUERY_KEY, catalogInventoryId], () =>
    CatalogInventoryService.getCatalogInventoryDetails({ catalogInventoryId, customerEnvId }),
  );
};

export default useGetCatalogInventoryDetails;
